import styled from 'styled-components';

export const ContentWrapper = styled.div`
  max-width: 48rem;
`;
